import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=0cbca3a8&scoped=true&"
import script from "./HeaderSearch.vue?vue&type=script&lang=ts&"
export * from "./HeaderSearch.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderSearch.vue?vue&type=style&index=0&id=0cbca3a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbca3a8",
  null
  
)

export default component.exports